import '@engine/lib/plugins/jquery.state_select';
import VirtualTerminal from '@engine/features/virtual_terminal';
import financialServicesBins from '@engine/features/financial_services_bins';
import { handleBirthDateFields } from '@engine/features/virtual_terminal/vt_handle_birth_date';
var LatamBankPayoutGateways = ['SantanderBrazil', 'Itau'];
var terminalIdSelector = 'input[name$="pay_by_link_form[terminal_id]"';
/* BEGINNING: Code used in the React components as well*/

function virtualTerminalStateDataReceived(data) {
  financialServicesBins.ukVisaBins = data.uk_bins.visa;
  financialServicesBins.ukDebitMastercardBins = data.uk_bins.master_maestro;
  VirtualTerminal.RequiredFields.updateRequiredFields(data);
  VirtualTerminal.OptionalFields.DLocal.updateOptionalFields(data.terminal);
  VirtualTerminal.OptionalFields.Razorpay.updateOptionalFields(data.terminal);
  VirtualTerminal.OptionalFields.PayUIndia.updateOptionalFields(data.terminal);
  VirtualTerminal.OptionalFields.WeChat.updateOptionalFields(data.terminal);
  VirtualTerminal.OptionalFields.Sofort.updateOptionalFields(data.terminal);
  VirtualTerminal.OptionalFields.Neosurf.updateOptionalFields(data.terminal);
  VirtualTerminal.Cash.updatePaymentTypes(data.supported_payment_types);
  VirtualTerminal.OnlineBanking.updateBankCodes(data.supported_bank_codes);
  VirtualTerminal.OnlineBanking.updatePaymentTypes(data.supported_payment_types);
  VirtualTerminal.BankPayout.updatePaymentTypes(data.supported_payment_types);
  VirtualTerminal.OnlineBanking.updateBlikMandatoryField(data.supported_payment_types);
  VirtualTerminal.OptionalFields.PandaPay.updateOptionalFields(data.terminal);
  VirtualTerminal.OptionalFields.PandaPay.updateOptionalFields(data.terminal);
  VirtualTerminal.OptionalFields.Girogate.updateOptionalFields(data.terminal);
  VirtualTerminal.OptionalFields.Gigadat.updateOptionalFields(data.terminal);
  VirtualTerminal.OptionalFields.Azupay.updateOptionalFields(data.terminal);
  VirtualTerminal.OptionalFields.PaysafeCard.updateOptionalFields(data.terminal);
  VirtualTerminal.OptionalFields.FitBank.updateOptionalFields(data.terminal);

  if (LatamBankPayoutGateways.includes(data.terminal.gateway)) {
    VirtualTerminal.OptionalFields["".concat(data.terminal.gateway)].updateOptionalFields(data.terminal);
  }

  VirtualTerminal.BankPayout.updateBankNames(data.bank_payout);
  VirtualTerminal.FxRates.updateFxRateSelect(data.fx);
  VirtualTerminal.PreconfiguredUrls.updateUrls(data.preconfigured_urls);
  VirtualTerminal.AccountOwnerAttributes.toggleAccountOwnerAttributes(data.terminal.features.supports_account_owner_attributes);
  VirtualTerminal.Travel.toggleTravelData(data.terminal.features.supports_travel, data.terminal.supported_travel_types);
  VirtualTerminal.NonReferencedRecurring.listenForInputsChange(data.features);
}

function setCurrency(terminalName) {
  var currency = terminalName.match(/\((.*?)\)/)[1];
  $('.currency').addClass('ml-5').html(currency);
}
/* END: Code used in the React components as well */


function virtualTerminalRequest(action, terminalId, trxType, paymentType) {
  $.ajax({
    type: 'GET',
    url: '/virtual-terminal/' + action,
    dataType: 'json',
    contentType: 'application/json',
    data: {
      terminal_id: terminalId,
      transaction_type: trxType,
      request_bins: financialServicesBins.isIncomplete(),
      payment_type: paymentType
    }
  }).done(function (data) {
    virtualTerminalStateDataReceived(data);
  });
}

function virtualTerminalChange() {
  var selectedTerminalIdValue = $(terminalIdSelector).val();

  if (selectedTerminalIdValue) {
    setCurrency($('#pay_by_link_terminal_id').text());
    var trxType = $('#pay_by_link_terminal_id').closest('form').attr('action').split('/').pop();
    var paymentType = $('#bank_payout_transaction_payment_type').val();
    virtualTerminalRequest('update_data_on_terminal_selection', selectedTerminalIdValue, trxType, paymentType);
    VirtualTerminal.BusinessAttributes.renderBusinessAttributeFields(selectedTerminalIdValue, trxType);
  }
} // We need to re-render attributes, mark required attributes
// and hide not necessary ones for specific payment type


function paymentTypeChange() {
  var trxType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'bank_payout';
  var terminalId = $("[name=\"".concat(trxType, "_transaction[terminal_id]\"]")).val();
  var paymentType = $("#".concat(trxType, "_transaction_payment_type")).val();
  virtualTerminalRequest('update_data_on_terminal_selection', terminalId, trxType, paymentType);
  VirtualTerminal.BusinessAttributes.renderBusinessAttributeFields(terminalId, trxType);
}

function initForTerminalChange() {
  if ($(terminalIdSelector).length) {
    virtualTerminalChange();
  }
}

function handleOnTerminalChange() {
  virtualTerminalChange();
  VirtualTerminal.PreconfiguredUrls.clearUrls();
}

function listenForCountryChange() {
  $('#billing_address_country').stateSelect();
  $('#shipping_address_country').stateSelect();
}

function listenForCardNumberChange() {
  $('input[name*=card_number]').on('keyup', function () {
    handleBirthDateFields();
  });
}

function listenForPaymentTypeChange() {
  var trxType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'bank_payout';
  $("#".concat(trxType, "_transaction_payment_type")).on('change', function () {
    paymentTypeChange();
  });
}

var Change = {
  listenForCountryChange: listenForCountryChange,
  listenForCardNumberChange: listenForCardNumberChange,
  listenForPaymentTypeChange: listenForPaymentTypeChange,
  virtualTerminalStateDataReceived: virtualTerminalStateDataReceived,
  setCurrency: setCurrency,
  initForTerminalChange: initForTerminalChange,
  handleOnTerminalChange: handleOnTerminalChange
};
export default Change;